// extracted by mini-css-extract-plugin
export default {"labelPlain":"SelectSingleFilter_labelPlain__wNdr1","labelPlainSelected":"SelectSingleFilter_labelPlainSelected__TAymz"};